import { ActionIcon, Card, Group, Text } from '@mantine/core';
import { IconDots, IconPencil, IconPlus, IconTrash } from '@tabler/icons-react';
import type { CSSProperties, ReactNode } from 'react';
import { isString } from '../../utils/utilFunctions';

export const Section = ({
    label,
    leftLabelBarNode,
    disabled,
    handleEditClick,
    handleAddClick,
    handleMoreClick,
    handleDeleteClick,
    withoutBackgroundColor,
    style,
    rightLabelBarNode,
    children,
}: {
    label?: ReactNode;
    leftLabelBarNode?: ReactNode;
    handleEditClick?: () => void;
    handleMoreClick?: () => void;
    handleDeleteClick?: () => void;
    handleAddClick?: () => void;
    withoutBackgroundColor?: boolean;
    style?: CSSProperties;
    rightLabelBarNode?: ReactNode;
    disabled?: boolean;
    children?: ReactNode;
}) => {
    const getEditButton = () => {
        if (handleEditClick) {
            return (
                <ActionIcon
                    size={'sm'}
                    onClick={handleEditClick}
                    variant={'transparent'}
                    color={'var(--mantine-color-base-button)'}
                >
                    <IconPencil />
                </ActionIcon>
            );
        }
        return;
    };

    const getAddButton = () => {
        if (handleAddClick) {
            return (
                <ActionIcon
                    size={'sm'}
                    onClick={handleAddClick}
                    variant={'transparent'}
                    color={'var(--mantine-color-base-button)'}
                >
                    <IconPlus />
                </ActionIcon>
            );
        }
        return;
    };

    const getDeleteButton = () => {
        if (handleDeleteClick) {
            return (
                <ActionIcon
                    size={'sm'}
                    onClick={handleDeleteClick}
                    variant={'transparent'}
                    color={'var(--mantine-color-base-button)'}
                >
                    <IconTrash />
                </ActionIcon>
            );
        }
        return;
    };

    const getMoreButton = () => {
        if (handleMoreClick) {
            return (
                <ActionIcon
                    size={'sm'}
                    onClick={handleMoreClick}
                    variant={'transparent'}
                    color={'var(--mantine-color-base-button)'}
                >
                    <IconDots />
                </ActionIcon>
            );
        }
        return;
    };

    return (
        <Card
            mih={32}
            withBorder
            padding={'sm'}
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                flexDirection: 'column',
                backgroundColor:
                    withoutBackgroundColor ? undefined
                    : (
                        Boolean(handleEditClick) ||
                        Boolean(handleAddClick) ||
                        disabled
                    ) ?
                        'var(--mantine-color-read-only-input)'
                    :   undefined,
            }}
        >
            <Card.Section
                mih={32}
                style={{
                    ...style,
                    padding: 10,
                    paddingTop: 2,
                    paddingBottom: children ? 10 : 0,
                }}
            >
                <div
                    style={{
                        width: '100%',
                        display: 'inline-flex',
                        paddingBottom: children ? 2 : 0,
                    }}
                >
                    {leftLabelBarNode}
                    <div
                        style={{
                            display: 'inline-flex',
                            flexGrow: 1,
                            alignItems: 'center',
                        }}
                    >
                        {isString(label) ?
                            <Text
                                style={{ lineHeight: 1.8 }}
                                size={'sm'}
                                c={'var(--mantine-text-secondary-color)'}
                            >
                                {label}
                            </Text>
                        :   label}
                    </div>
                    <Group
                        justify="flex-end"
                        gap={6}
                        style={{ display: 'inline-flex', alignItems: 'center' }}
                    >
                        {getEditButton()}
                        {getAddButton()}
                        {getDeleteButton()}
                        {getMoreButton()}
                        {rightLabelBarNode}
                    </Group>
                </div>
                {children}
            </Card.Section>
        </Card>
    );
};
